export default "__VITE_ASSET__bhteMk9d__"